export default {
    "System.Manage": {
        sortOrder: 1000,
        caption: '系统设置',
        path: '/system/setting',
        icon: 'el-icon-s-tools',
        children: {
            "System.User":
            {
                permissionGroupId: "System.User.Manage",
                sortOrder: 1000,
                caption: '系统用户管理',
                path: '/user',
                icon: 'el-icon-user-solid',
            },
            "System.Role":
            {
                permissionGroupId: "System.Role.Manage",
                sortOrder: 1000,
                caption: '角色管理',
                path: '/role',
                icon: 'el-icon-s-custom',
            },
            "System.Log":
            {
                permissionGroupId: "System.Log.Manage",
                sortOrder: 1000,
                caption: '用户操作日志',
                path: '/log',
                icon: 'el-icon-notebook-1',
            }
        }
    }

};



// WEBPACK FOOTER //
// ./src/modules/system/menu.js